import { HttpClient } from '@angular/common/http';
import { Component,OnInit, Input, Output, EventEmitter } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { ReportDialog } from '../reportdialog';

@Component({
  selector: 'app-registration-report-header',
  templateUrl: './registration-report-header.component.html',
  styleUrls: ['./registration-report-header.component.scss']
})
export class RegistrationReportHeaderComponent implements OnInit {
  public link: string = 'https://www.clickdimensions.com/links/TestPDFfile.pdf';
  @Input() pageHeading:string;
  isgraphs:boolean= false;
  isShowDivIf:boolean = false

  
  @Output() openPDF: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() exportexcel: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() barChart: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() pieChart: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() lineChart: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() toggleDisplayDivIf: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  constructor(public http:HttpClient,public dialog: MatDialog) { }

  ngOnInit(): void {
    // this.pageHeading = 'Patient Registration Reports';
    console.log(this.pageHeading)
    if(this.pageHeading === 'Grapical Patient Registration'){
      this.isgraphs = true;
    }
    else{
      this.isgraphs = false;
    }
  }

  toggleDisplayDiv(event: MouseEvent) {
    this.isShowDivIf = !this.isShowDivIf;
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ReportDialog, {
      width: '250px',
      data: ''
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      // this.animal = result;
    });
  }

  // WhatsApp(){
  //   return new Promise(resolve => {
  //     console.log("Before API")
  //     this.http.get("https://api.whatsapp.com/send?phone=15551234567&text=I'm%20interested%20in%20your%20car%20for%20sale").pipe(map((response: any) => response.json())).subscribe(data => {
  //       resolve(data);
  //       console.log("After API",data)
  //     }, err => {
  //     });
  //   });
    
  // }
//   genericSocialShare(){
//     var url="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=pankajabc65@gmail.com&su=Report sharing&body="+this.link+"&ui=2&tf=1&pli=1";
//     window.open(url,'sharer','toolbar=0,status=0,width=648,height=395');
//     return true;
//  }
}
